var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewEmptyHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a186a73b-502a-422d-9407-ce2272464e1d",
    "data-name": "Laag 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 271.5 243.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a70d5a2e-bdae-47c1-9509-270ec87b1902{fill:#203250;}.ae03519e-03c1-4bca-b287-bc6c64dc4d69{fill:#fff;}.a98b1385-1095-4f78-8376-174dd2d758a2{fill:#f2f2f2;}.a228c1c3-b9d4-478a-9ae6-34109f5f84d8{fill:#e6e6e6;}.ad694f79-8aff-4581-a20f-b4087d69a595{fill:#ccc;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bb7c39fd-bd28-47a1-87e3-33968829320c",
    "data-name": "Group 264 - 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "e85c71f0-1018-4304-a656-dcc9ae2d58dc",
    "data-name": "Path 1206",
    className: "a70d5a2e-bdae-47c1-9509-270ec87b1902",
    d: "M139,.53l-8.83,2.28L21.37,30.87l-8.83,2.28A16.73,16.73,0,0,0,.53,53.5L38.84,202.05a16.72,16.72,0,0,0,20.35,12h0l126.46-32.61h0a16.72,16.72,0,0,0,12-20.35L159.4,12.53A16.73,16.73,0,0,0,139,.53Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af5706c4-d2dd-402d-957c-4f0fca3bc965",
    "data-name": "Path 1207",
    className: "ae03519e-03c1-4bca-b287-bc6c64dc4d69",
    d: "M140.25,5.19l-10.47,2.7L24.2,35.11l-10.46,2.7A11.9,11.9,0,0,0,5.19,52.3l38.3,148.55A11.92,11.92,0,0,0,58,209.4h0l126.46-32.61h0a11.91,11.91,0,0,0,8.54-14.5L154.74,13.74A11.91,11.91,0,0,0,140.25,5.19Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f8627d66-02d1-41c4-a52d-767c69087b79",
    "data-name": "Path 1208",
    className: "a98b1385-1095-4f78-8376-174dd2d758a2",
    d: "M132.34,53.29l-64,16.5A2.78,2.78,0,0,1,67,64.4l64-16.5a2.78,2.78,0,1,1,1.39,5.39Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a2b04e09-6fd6-44db-bef4-e990bd736dda",
    "data-name": "Path 1209",
    className: "a98b1385-1095-4f78-8376-174dd2d758a2",
    d: "M145.8,59.52,70.71,78.88a2.78,2.78,0,0,1-1.39-5.39l75.09-19.36a2.78,2.78,0,1,1,1.39,5.39Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f2914475-adce-48bf-9c1d-30b8e1a46a5e",
    "data-name": "Path 1210",
    className: "a98b1385-1095-4f78-8376-174dd2d758a2",
    d: "M142.85,94l-64,16.5a2.78,2.78,0,0,1-1.39-5.39l64-16.5A2.78,2.78,0,0,1,142.85,94Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "be848c39-b5a6-4427-a221-94916e991fa1",
    "data-name": "Path 1211",
    className: "a98b1385-1095-4f78-8376-174dd2d758a2",
    d: "M156.31,100.27,81.22,119.63a2.78,2.78,0,0,1-1.39-5.39l75.09-19.36a2.78,2.78,0,1,1,1.39,5.38h0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ef89ffdc-658a-4a4f-b541-916d89d8bd37",
    "data-name": "Path 1212",
    className: "a98b1385-1095-4f78-8376-174dd2d758a2",
    d: "M153.36,134.79l-64,16.5A2.78,2.78,0,0,1,88,145.9l64-16.5a2.78,2.78,0,1,1,1.39,5.39Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a9fa97b6-c376-4504-a4d4-7bc9b9a9edf5",
    "data-name": "Path 1213",
    className: "a98b1385-1095-4f78-8376-174dd2d758a2",
    d: "M166.82,141,91.73,160.38A2.78,2.78,0,0,1,90.34,155l75.09-19.36a2.78,2.78,0,1,1,1.39,5.38Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "befaf3df-81cb-46fa-be96-bbcdc91e9027",
    "data-name": "Path 1214",
    className: "a228c1c3-b9d4-478a-9ae6-34109f5f84d8",
    d: "M57.45,86.71,34.81,92.54a1.33,1.33,0,0,1-1.63-1L28,71.43a1.34,1.34,0,0,1,1-1.62L51.58,64a1.34,1.34,0,0,1,1.63,1l5.2,20.15a1.35,1.35,0,0,1-1,1.63Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b6397d5e-56db-4bfc-8b2e-1dcc20872cb5",
    "data-name": "Path 1215",
    className: "a228c1c3-b9d4-478a-9ae6-34109f5f84d8",
    d: "M68,127.45l-22.64,5.84a1.35,1.35,0,0,1-1.63-1l-5.2-20.15a1.35,1.35,0,0,1,1-1.63l22.64-5.83a1.34,1.34,0,0,1,1.63,1l5.2,20.16A1.34,1.34,0,0,1,68,127.45Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ea76cbce-8a74-4453-b3d9-461dad0a2d8a",
    "data-name": "Path 1216",
    className: "a228c1c3-b9d4-478a-9ae6-34109f5f84d8",
    d: "M78.47,168.2,55.82,174a1.34,1.34,0,0,1-1.62-1L49,152.93a1.35,1.35,0,0,1,1-1.63l22.64-5.83a1.32,1.32,0,0,1,1.62.95l5.2,20.16A1.32,1.32,0,0,1,78.47,168.2Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b1205bc4-43c4-47ee-9110-65986132d129",
    "data-name": "Path 1217",
    className: "a228c1c3-b9d4-478a-9ae6-34109f5f84d8",
    d: "M227.28,38.18H96.63A16.73,16.73,0,0,0,79.92,54.89V208.3A16.73,16.73,0,0,0,96.63,225H227.28A16.73,16.73,0,0,0,244,208.3V54.89A16.73,16.73,0,0,0,227.28,38.18Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a333e11b-22f6-4142-a557-84531dc62803",
    "data-name": "Path 1218",
    className: "ae03519e-03c1-4bca-b287-bc6c64dc4d69",
    d: "M227.28,43H96.63a11.92,11.92,0,0,0-11.9,11.9V208.3a11.92,11.92,0,0,0,11.9,11.9H227.28a11.92,11.92,0,0,0,11.9-11.9V54.89A11.91,11.91,0,0,0,227.28,43Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "bbf70bca-d1f1-40ad-a163-e5292b629ce4",
    "data-name": "Ellipse 95",
    className: "a70d5a2e-bdae-47c1-9509-270ec87b1902",
    cx: 241,
    cy: 213.17,
    r: 30.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "e95fe95f-9e39-44a4-bac8-2f0bdbae08ab",
    "data-name": "Path 1219",
    className: "ae03519e-03c1-4bca-b287-bc6c64dc4d69",
    d: "M255.59,209.19H245v-10.6a4,4,0,1,0-7.95,0h0v10.6H226.42a4,4,0,1,0,0,8H237v10.61a4,4,0,0,0,7.95,0V217.15h10.61a4,4,0,0,0,0-8h0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f610a7ea-48ea-4ebe-9e50-52e4b1076321",
    "data-name": "Path 1220",
    className: "a228c1c3-b9d4-478a-9ae6-34109f5f84d8",
    d: "M207.62,127.29H141.55a2.78,2.78,0,0,1,0-5.56h66.07a2.78,2.78,0,0,1,0,5.56Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f0fe449b-cf34-40c5-a801-d85dfea21041",
    "data-name": "Path 1221",
    className: "a228c1c3-b9d4-478a-9ae6-34109f5f84d8",
    d: "M219.09,136.68H141.55a2.78,2.78,0,0,1,0-5.56h77.54a2.78,2.78,0,1,1,0,5.56Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b4054500-088b-48c0-9d75-b7eb44dd0e42",
    "data-name": "Path 1222",
    className: "a228c1c3-b9d4-478a-9ae6-34109f5f84d8",
    d: "M207.62,169.37H141.55a2.78,2.78,0,0,1,0-5.56h66.07a2.78,2.78,0,0,1,0,5.56Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b33ef158-d2d8-4e0b-81bb-4e5927502e77",
    "data-name": "Path 1223",
    className: "a228c1c3-b9d4-478a-9ae6-34109f5f84d8",
    d: "M219.09,178.76H141.55a2.78,2.78,0,0,1,0-5.56h77.54a2.78,2.78,0,1,1,0,5.56Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b6c70dcf-dad3-457c-9cae-cbf1ea782bb7",
    "data-name": "Path 1224",
    className: "a228c1c3-b9d4-478a-9ae6-34109f5f84d8",
    d: "M126.75,140.94H103.37a1.33,1.33,0,0,1-1.34-1.33V118.8a1.34,1.34,0,0,1,1.34-1.34h23.38a1.35,1.35,0,0,1,1.34,1.34v20.81A1.33,1.33,0,0,1,126.75,140.94Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a81558f8-7a5f-4045-9d8b-cf0e6370acd2",
    "data-name": "Path 1225",
    className: "a228c1c3-b9d4-478a-9ae6-34109f5f84d8",
    d: "M126.75,183H103.37a1.33,1.33,0,0,1-1.34-1.33V160.88a1.35,1.35,0,0,1,1.34-1.34h23.38a1.35,1.35,0,0,1,1.34,1.34v20.81A1.34,1.34,0,0,1,126.75,183Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f38f2aac-0a12-4248-b655-4b10f85fce80",
    "data-name": "Path 1226",
    className: "ad694f79-8aff-4581-a20f-b4087d69a595",
    d: "M207.69,80.44H159a2.78,2.78,0,0,1,0-5.56h48.71a2.78,2.78,0,0,1,0,5.56Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "be5f3d74-e93d-48bc-8119-d69900ab0c24",
    "data-name": "Path 1227",
    className: "ad694f79-8aff-4581-a20f-b4087d69a595",
    d: "M219.17,89.84H159a2.79,2.79,0,0,1,0-5.57h60.19a2.79,2.79,0,0,1,0,5.57Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bf1f27fa-a44a-47b4-a243-86fb943266bf",
    "data-name": "Path 1228",
    className: "ad694f79-8aff-4581-a20f-b4087d69a595",
    d: "M148.2,101.22H103.29A1.34,1.34,0,0,1,102,99.88v-35a1.33,1.33,0,0,1,1.33-1.34H148.2a1.33,1.33,0,0,1,1.33,1.34v35a1.34,1.34,0,0,1-1.33,1.34Z",
    transform: "translate(0 0)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewEmptyHover);
export default __webpack_public_path__ + "static/media/new-empty-hover.4d5f0509.svg";
export { ForwardRef as ReactComponent };